import { Link, useNavigate } from "react-router";
import { ChevronRight } from "lucide-react";
import { BulkShipForm } from "./bulk-ship-form";
import { useTranslation } from "react-i18next";

export default function BulkShipScreen() {
  const navigate = useNavigate();
  const { t } = useTranslation("app");

  return (
    <div className="-mx-4 md:-mx-8 -mt-6 min-h-[calc(100vh-200px)] flex flex-col bg-background">
      <div className="px-6 md:px-14 pt-10 pb-6">
        <div className="flex items-center gap-2 text-sm text-default-500 mb-4">
          <Link
            to="/dashboard"
            className="hover:text-foreground hover:underline"
          >
            {t("bulkShip.breadcrumbShipments")}
          </Link>
          <ChevronRight className="h-3.5 w-3.5" />
          <span className="text-default-700">
            {t("bulkShip.breadcrumbBulkShip")}
          </span>
        </div>

        <div className="text-tiny font-semibold uppercase tracking-wider text-default-500 mb-3">
          {t("bulkShip.eyebrow")}
        </div>
        <h1 className="text-3xl sm:text-4xl font-bold leading-[1.05] tracking-tight">
          {t("bulkShip.heroTitlePrefix")}{" "}
          <em className="text-primary">{t("bulkShip.heroTitleEmphasis")}</em>
        </h1>
        <p className="mt-3 max-w-[680px] text-base leading-relaxed text-default-600">
          {t("bulkShip.heroBody")}
        </p>
      </div>

      <div className="flex-1 flex flex-col">
        <BulkShipForm onClose={() => void navigate("/dashboard")} />
      </div>
    </div>
  );
}
